import React, { useContext, useEffect } from 'react'
import { Outlet } from 'react-router'
import { StoresContext } from '@App/contexts'

const RightsholderOverclaimLayout = () => {
    const { overclaimSearchStore, overclaimSearchBulkActionStore } = useContext(StoresContext)
    useEffect(() => () => {
        overclaimSearchStore.resetStore()
        overclaimSearchBulkActionStore.resetStore()
    })

    return (
        <>
            <title>Overclaims Tool</title>
            <Outlet />
        </>
    )
}

export default RightsholderOverclaimLayout
